import userService from '@/services/user';
import router from '@/router.js';

export default {
  state: {
    user: null,
  },
  getters: {
    user: state => state.user,
  },
  actions: {
    getUser({ commit }) {
      return new Promise((resolve, reject) => {
        userService.getUser()
          .then((response) => {
            commit('set_user', response.data);
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
  },
  mutations: {
    set_user(state, user) {
      state.user = user;
    },
  },
};
